import{scenarioCatalogueFilterTypes} from './../../constants';


export const addFilter = (name, value) => {
    return {
        type:scenarioCatalogueFilterTypes().addFilter,
        name,
        value
    };
};



export const removeFilter = (name, value) => {
    return {
        type:scenarioCatalogueFilterTypes().removeFilter,
        name,
        value
    };
};



export const clearFilters = () => {
    return {
        type:scenarioCatalogueFilterTypes().clearFilters
    };
};
